import configureStoreDev from './configStore.dev';
import configureStoreProd from './configStore.prod';

export default process.env.NODE_ENV !== 'development' ? configureStoreProd : configureStoreDev;